import React, { useCallback, useState } from 'react'
import Header from './components/Header'
import Hero from './components/Hero'
import Overview from './components/Overview'
import Explore from './components/Explore'
import Numbers from './components/Numbers'
import Timeline from './components/Timeline'
import Places from './components/Places'
import NewsSection from './components/NewsSection'
import MapSection from './components/MapSection'
import Gallery from './components/Gallery'
import Footer from './components/Footer'
import BackToTop from './components/BackToTop'
import { LightboxProvider } from './components/Lightbox'
import { useScrollEffects } from './hooks/useScrollEffects'
import { useI18n } from './i18n/LanguageContext'
import Seo from './i18n/Seo'

function Page() {
  const { t } = useI18n()
  const [area, setArea] = useState('nanovitsa')
  useScrollEffects()

  // Used by the place cards: switch the Explore tab, then scroll to it
  const openArea = useCallback((id) => {
    setArea(id)
    document.getElementById('explore')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [])

  return (
    <LightboxProvider>
      <Seo />
      <a className="skip-link" href="#overview">{t.common.skip}</a>
      <Header />
      <main>
        <Hero />
        <Overview />
        <Explore active={area} onChange={setArea} />
        <Numbers />
        <Timeline />
        <Places onOpenArea={openArea} />
        <NewsSection />
        <MapSection />
        <Gallery />
      </main>
      <Footer />
      <BackToTop />
    </LightboxProvider>
  )
}

export default Page
